import styled, { css } from 'styled-components';

export const Header = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.white.primary};
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    max-height: fit-content;
    padding: 24px;
    width: 100%;
  `}
`;

export const BackButtonWrapper = styled.div`
  ${({ theme }) => css`
    button {
      color: ${theme.v2.colors.neutral.lowMedium};
      :hover {
        color: ${theme.v2.colors.neutral.lowDark};
      }
      svg {
        width: 18px;
        height: 18px;
        @media (max-width: ${theme.v2.breakpoints.md}) {
          width: 24px;
          height: 24px;
        }
      }
    }
  `}
`;

export const HgLogo = styled.img`
  ${({ theme }) => css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 103px;
    }
  `}
`;
